import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Card,
  CardContent,
  LinearProgress,
  Chip,
  IconButton
} from '@mui/material';
import {
  TrendingUp as TrendingIcon,
  People as PeopleIcon,
  Newspaper as NewsIcon,
  Visibility as ViewIcon,
  ArrowForward as ArrowIcon,
  FormatQuote as QuoteIcon
} from '@mui/icons-material';

const OrganicShapesSection = () => {
  const [hoveredStat, setHoveredStat] = useState(null);
  const [hoveredCase, setHoveredCase] = useState(null);

  const stats = [
    { number: '500+', label: 'Aktif Haber Sitesi', icon: <NewsIcon /> },
    { number: '50+', label: 'Farklı Kategori', icon: <TrendingIcon /> },
    { number: '1M+', label: 'Günlük Okuyucu', icon: <ViewIcon /> },
    { number: '10K+', label: 'Kayıtlı Kullanıcı', icon: <PeopleIcon /> }
  ];

  const caseStudies = [
    {
      category: 'Yerel Haber',
      title: 'Günlük 50K Ziyaretçiye Ulaştık',
      image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=300&fit=crop',
      color: '#ff6b35'
    },
    {
      category: 'Ulusal Platform',
      title: 'Sayfa Hızımız %80 Arttı',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&h=300&fit=crop',
      color: '#8b5cf6'
    },
    {
      category: 'Bölgesel Medya',
      title: 'Mobil Trafiğimiz İkiye Katlandı',
      image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=300&fit=crop',
      color: '#ec4899'
    }
  ];

  const processes = [
    { step: '1', title: 'Kurulum', description: '15 dakikada platformunuz hazır' },
    { step: '2', title: 'Tasarım', description: 'Widget\'larla özelleştirin' },
    { step: '3', title: 'İçerik', description: 'Haber eklemeye başlayın' },
    { step: '4', title: 'Yayın', description: 'Siteniz canlı yayında' }
  ];

  const partners = [
    { name: 'Google Analytics', logo: '📊' },
    { name: 'Cloudflare', logo: '☁️' },
    { name: 'AWS', logo: '🚀' },
    { name: 'Stripe', logo: '💳' },
    { name: 'Mailchimp', logo: '📧' }
  ];

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      
      {/* Bölüm 1: İstatistikler - Koyu Arka Plan */}
      <Box 
      sx={{
        background: '#f8f9fa ',
        pt: { xs: 8, md: 12 },
        position: 'relative',
        overflow: 'hidden',
        pb: 0
      }}
      >
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #0f0f23 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden',
          pb: 0,
          borderRadius: '0 0 400px 0'
        }}
      >
        {/* Organik Şekiller */}
        <Box
          sx={{
            position: 'absolute',
            top: -100,
            left: -100,
            width: 400,
            height: 400,
            background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
            borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
            opacity: 0.15,
            filter: 'blur(60px)',
            animation: 'morph 8s ease-in-out infinite'
          }}
        />

        {/* Nokta Pattern */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 50,
            right: 50,
            width: 150,
            height: 150,
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 2px, transparent 2px)',
            backgroundSize: '20px 20px',
            opacity: 0.3
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2, mb: 8 }}>
          {/* İçerik */}
          <Grid container spacing={4} alignItems="center" mb={8}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 3, mb: 4 }}>
                <Box
                  sx={{
                    position: 'relative',
                    width: '45%',
                    height: 280,
                    borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%',
                    overflow: 'hidden',
                    border: '8px solid rgba(255, 107, 53, 0.3)',
                    animation: 'float 6s ease-in-out infinite'
                  }}
                >
                  <img
                    src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300&h=300&fit=crop"
                    alt="Team"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </Box>

                <Box
                  sx={{
                    position: 'relative',
                    width: '45%',
                    height: 280,
                    borderRadius: '50% 50% 50% 50% / 40% 40% 60% 60%',
                    overflow: 'hidden',
                    border: '8px solid rgba(255, 107, 53, 0.3)',
                    mt: 4,
                    animation: 'float 6s ease-in-out infinite 1s'
                  }}
                >
                  <img
                    src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=300&h=300&fit=crop"
                    alt="Team"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '2rem', md: '3rem' },
                  fontWeight: 800,
                  color: 'white',
                  mb: 3,
                  lineHeight: 1.2
                }}
              >
                Haber Platformunuzun{' '}
                <span style={{ color: '#ff6b35' }}>Başarısı</span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: '1.1rem',
                  lineHeight: 1.8,
                  mb: 3
                }}
              >
                Sürekli gelişen 70 ekosistem ortağımız ve binlerce memnun müşterimizle
                stratejik üretim ürünlerinde işbirliği yapıyoruz.
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 4 }}>
                {['Kaliteli ortaklık ilişkileri', 'Objektif olarak otomatik veri üstünlüğü', 'Yeniden pazarlanabilir niş açık kaynak'].map((text, idx) => (
                  <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: 12, height: 12, borderRadius: '50%', background: '#ff6b35' }} />
                    <Typography sx={{ color: 'white', fontSize: '0.95rem' }}>{text}</Typography>
                  </Box>
                ))}
              </Box>
              <Button
                variant="contained"
                endIcon={<ArrowIcon />}
                sx={{
                  background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: '50px',
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  boxShadow: '0 8px 24px rgba(255, 107, 53, 0.4)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #f7931e 0%, #ff6b35 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 32px rgba(255, 107, 53, 0.5)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Daha Fazla
              </Button>
            </Grid>
          </Grid>

          {/* İstatistikler */}
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255,255,255,0.6)',
                fontSize: '0.9rem',
                letterSpacing: '0.1em'
              }}
            >
              7 Yılda Ulaştığımız Başarılar
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {stats.map((stat, index) => (
              <Grid item xs={6} md={3} key={index}>
                <Box
                  onMouseEnter={() => setHoveredStat(index)}
                  onMouseLeave={() => setHoveredStat(null)}
                  sx={{
                    textAlign: 'center',
                    p: 3,
                    borderRadius: 4,
                    background: hoveredStat === index ? 'rgba(255, 107, 53, 0.1)' : 'transparent',
                    border: hoveredStat === index ? '1px solid rgba(255, 107, 53, 0.3)' : '1px solid transparent',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    transform: hoveredStat === index ? 'translateY(-5px)' : 'none'
                  }}
                >
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      background: 'rgba(255, 107, 53, 0.15)',
                      color: '#ff6b35',
                      mb: 2,
                      fontSize: '1.8rem'
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      color: 'white',
                      fontWeight: 800,
                      mb: 1,
                      fontSize: { xs: '2rem', md: '2.5rem' }
                    }}
                  >
                    {stat.number}
                    <span style={{ color: '#ff6b35', fontSize: '0.6em' }}>↑</span>
                  </Typography>
                  <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.95rem' }}>
                    {stat.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* BÜYÜK DALGA GEÇİŞİ - Koyu -> Açık */}
        {/* <Box
          sx={{
            position: 'relative',
            bottom: 0,
            left: 0,
            width: '100%',
            overflow: 'hidden',
            lineHeight: 0,
            mt: 8
          }}
        >
          <svg
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
            style={{ width: '100%', height: '200px', display: 'block' }}
          >
            <path
              d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,165.3C1248,149,1344,107,1392,85.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              fill="#f8f9fa"
            />
          </svg>
        </Box> */}
      </Box>
      </Box>

      {/* Bölüm 2: CEO Yorumu - Açık Arka Plan */}
    <Box
    sx={{
      background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #0f0f23 100%)',
      position: 'relative',
      overflow: 'hidden',
      pb: 0,

    }}
    >
    <Box
        sx={{
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%)',
          pt: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden',
          pb: 0,
          borderRadius: '400px 0 400px 0'
        }}
      >
        {/* Organik Şekil */}
        <Box
          sx={{
            position: 'absolute',
            bottom: -150,
            left: -100,
            width: 500,
            height: 500,
            background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
            borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 10s ease-in-out infinite reverse'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2, mb: 8 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Chip
                label="MÜŞTERİLERİMİZ"
                sx={{
                  background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(247, 147, 30, 0.1))',
                  color: '#ff6b35',
                  fontWeight: 600,
                  mb: 3,
                  fontSize: '0.85rem'
                }}
              />
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '2rem', md: '2.8rem' },
                  fontWeight: 800,
                  color: '#1a1a2e',
                  mb: 3,
                  lineHeight: 1.3
                }}
              >
                CEO'muz Müşterilerimiz Hakkında{' '}
                <span style={{ color: '#ff6b35' }}>Ne Söylüyor</span>
              </Typography>
              <Box sx={{ position: 'relative', pl: 4, borderLeft: '4px solid #ff6b35', mb: 4 }}>
                <QuoteIcon
                  sx={{
                    position: 'absolute',
                    left: -20,
                    top: -10,
                    fontSize: 40,
                    color: '#ff6b35',
                    opacity: 0.3
                  }}
                />
                <Typography
                  sx={{
                    color: '#495057',
                    fontSize: '1.1rem',
                    lineHeight: 1.8,
                    fontStyle: 'italic',
                    mb: 3
                  }}
                >
                  "Müşterilerimizin iş fonksiyonlarını yenilemelerine yardımcı olarak
                  markalaşabilir organizasyonlar yaratıyoruz."
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '1.1rem' }}>
                  — Rilika Astrology
                </Typography>
                <Typography sx={{ color: '#6c757d', fontSize: '0.95rem' }}>
                  CEO & Founder
                </Typography>
              </Box>
              <Button
                variant="contained"
                endIcon={<ArrowIcon />}
                sx={{
                  background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: '50px',
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  boxShadow: '0 8px 24px rgba(255, 107, 53, 0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #f7931e 0%, #ff6b35 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 32px rgba(255, 107, 53, 0.4)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Hikayeyi Oku
              </Button>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ position: 'relative', width: '100%', maxWidth: 500, mx: 'auto' }}>
                <Box
                  sx={{
                    position: 'relative',
                    width: '100%',
                    height: 500,
                    borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%',
                    overflow: 'hidden',
                    border: '12px solid white',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                    animation: 'float 8s ease-in-out infinite'
                  }}
                >
                  <img
                    src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=500&h=500&fit=crop"
                    alt="CEO"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </Box>

                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 50,
                    left: -30,
                    width: 120,
                    height: 120,
                    background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                    borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 10px 30px rgba(255, 107, 53, 0.3)',
                    animation: 'pulse 3s ease-in-out infinite'
                  }}
                >
                  <QuoteIcon sx={{ fontSize: 50, color: 'white' }} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>

        {/* BÜYÜK DALGA GEÇİŞİ - Açık -> Koyu */}
        {/* <Box
          sx={{
            position: 'relative',
            bottom: 0,
            left: 0,
            width: '100%',
            overflow: 'hidden',
            lineHeight: 0,
            mt: 8
          }}
        >
          <svg
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
            style={{ width: '100%', height: '200px', display: 'block' }}
          >
            <path
              d="M0,224L48,213.3C96,203,192,181,288,186.7C384,192,480,224,576,218.7C672,213,768,171,864,165.3C960,160,1056,192,1152,197.3C1248,203,1344,181,1392,170.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              fill="#0f0f23"
            />
          </svg>
        </Box> */}
      </Box>
    </Box>

      {/* Bölüm 3: Başarı Hikayeleri - Koyu */}
     <Box
     sx={{
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%)',
      pt: { xs: 8, md: 12 },
      position: 'relative',
      overflow: 'hidden'
     }}>
     <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #0f0f23 100%)',
          pt: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '0 0 400px 0'
        }}
      >
        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: '2rem', md: '3rem' },
                fontWeight: 800,
                color: 'white',
                mb: 2
              }}
            >
              En İyi İşlerimize{' '}
              <span style={{ color: '#ff6b35' }}>Göz Atın</span>
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.1rem', mb: 4 }}>
              Başarı Hikayelerini Görüntüleyin
            </Typography>
            <Button
              variant="contained"
              endIcon={<ArrowIcon />}
              sx={{
                background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                color: 'white',
                px: 4,
                py: 1.5,
                borderRadius: '50px',
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 600,
                boxShadow: '0 8px 24px rgba(255, 107, 53, 0.4)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #f7931e 0%, #ff6b35 100%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 32px rgba(255, 107, 53, 0.5)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Tüm Projeler
            </Button>
          </Box>

          <Grid container spacing={4}>
            {caseStudies.map((study, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  onMouseEnter={() => setHoveredCase(index)}
                  onMouseLeave={() => setHoveredCase(null)}
                  sx={{
                    background: 'rgba(255,255,255,0.05)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: 4,
                    overflow: 'hidden',
                    cursor: 'pointer',
                    transition: 'all 0.4s ease',
                    transform: hoveredCase === index ? 'translateY(-10px)' : 'none',
                    boxShadow: hoveredCase === index ? `0 20px 40px ${study.color}30` : 'none'
                  }}
                >
                  <Box sx={{ position: 'relative', height: 250, overflow: 'hidden' }}>
                    <img
                      src={study.image}
                      alt={study.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.4s ease',
                        transform: hoveredCase === index ? 'scale(1.1)' : 'scale(1)'
                      }}
                    />
                    <Box sx={{ position: 'absolute', top: 20, left: 20 }}>
                      <Chip
                        label={study.category}
                        sx={{
                          background: study.color,
                          color: 'white',
                          fontWeight: 600,
                          fontSize: '0.75rem'
                        }}
                      />
                    </Box>
                  </Box>
                  <CardContent sx={{ p: 3 }}>
                    <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, mb: 2 }}>
                      {study.title}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Typography
                        sx={{
                          color: study.color,
                          fontWeight: 600,
                          fontSize: '0.9rem',
                          opacity: hoveredCase === index ? 1 : 0,
                          transform: hoveredCase === index ? 'translateX(0)' : 'translateX(-10px)',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        Detayları Gör
                      </Typography>
                      <IconButton
                        sx={{
                          color: study.color,
                          opacity: hoveredCase === index ? 1 : 0,
                          transform: hoveredCase === index ? 'translateX(0)' : 'translateX(10px)',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <ArrowIcon />
                      </IconButton>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
     </Box>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes morph {
          0%, 100% {
            border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
          }
          25% {
            border-radius: 60% 40% 50% 50% / 30% 60% 40% 60%;
          }
          50% {
            border-radius: 50% 50% 30% 70% / 50% 30% 70% 40%;
          }
          75% {
            border-radius: 30% 70% 60% 40% / 60% 40% 50% 50%;
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
      `}</style>
    </Box>
  );
};

export default OrganicShapesSection;